/**
 * @generated SignedSource<<5e42aef6e7a2a2f5b50cb9d943994735>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reselleraccountid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerprogramid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendoraccountid"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "reselleraccountid",
        "variableName": "reselleraccountid"
      },
      {
        "kind": "Variable",
        "name": "resellerprogramid",
        "variableName": "resellerprogramid"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendoraccountid"
      }
    ],
    "concreteType": "VendorSubscriptionResellersConnection",
    "kind": "LinkedField",
    "name": "getvendorssubscriptionbyreseller2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VendorSubscriptionReseller",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appSku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAppName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAppSku",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramSubscriptionFetchQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerProgramSubscriptionFetchQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3562919573f06b80ef1145274439ad3e",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramSubscriptionFetchQuery",
    "operationKind": "query",
    "text": "query ResellerProgramSubscriptionFetchQuery(\n  $vendoraccountid: UUID!\n  $reselleraccountid: UUID!\n  $resellerprogramid: UUID\n) {\n  getvendorssubscriptionbyreseller2(vendoraccountid: $vendoraccountid, reselleraccountid: $reselleraccountid, resellerprogramid: $resellerprogramid) {\n    totalCount\n    nodes {\n      customerAccountName\n      customerAppId\n      appName\n      appSku\n      resellerAppName\n      resellerAppSku\n    }\n  }\n}\n"
  }
};
})();

node.hash = "3ef81c267bddb65b5a9226852bb571df";

module.exports = node;
